import script from "./ProVenueFollowers.vue?vue&type=script&setup=true&lang=js"
export * from "./ProVenueFollowers.vue?vue&type=script&setup=true&lang=js"

import "./ProVenueFollowers.vue?vue&type=style&index=0&id=02a26de3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a26de3"]])

export default __exports__